// resetLayoutProperties resets the layout properties when you drag and
// drop an form element from a container into a section
export const resetLayoutProperties = (section: any, item: any, newItem: any) => {
  if (!section.properties.layout && item.properties.layout) {
    delete newItem.properties.layout
    if (
      (item.properties.layout && !item.properties.layout.parent) ||
      item.type === "Container"
    ) {
      newItem.properties.layout = {
        direction: "row",
      }
    }
  }
}
